import React from "react";

const CheckBox = ({
  value,
  CheckBoxText,
  name,
  checked,
  onChange,
  dataId,
  className,
  labelClassName,
  labelText,
  onClick

}) => {
  return (
    <>
      <input
        type="checkbox"
        className={className}
        value={value}
        id={dataId}
        name={name}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
      />
      { labelText}
      <label className={labelClassName} htmlFor={dataId} dangerouslySetInnerHTML={{ __html: CheckBoxText }}>
      </label>
    </>
  );
};
export default CheckBox;
